// Import the React components to include in the bundle

import ClayCalc from './ClayCalc';
